import { QRCodeSVG } from 'qrcode.react';

import { Flex } from 'components/uikit';

interface PaymentPageQrProps {
  size?: number;
  value?: string;
}

export const PaymentPageQr = ({ size = 160, value }: PaymentPageQrProps) => {
  return (
    <Flex
      w={['180px', '200px']}
      h={['180px', '200px']}
      bg={['transparent', 'payment.qrBackground']}
      borderRadius='13px'
      justifyContent='center'
      alignItems='center'
      mx={['auto', '0']}
      p='12px'
    >
      <QRCodeSVG
        bgColor='#fff'
        fgColor='#000'
        value={value ?? window.location.href}
        size={size}
      />
    </Flex>
  );
};
